import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    lastFeatureCta: 'Request a card',
    subtitle: 'Manage your professional expenses on your own',
    title: 'Welcome {firstName} 🎉',
  },
  fr: {
    lastFeatureCta: 'Demander une carte',
    subtitle: 'Gérez vos dépenses professionnelles en toute autonomie',
    title: 'Bienvenue {firstName} 🎉',
  },
} as const);

export default locales;
